var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoteOperations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "rgb(99,115,129)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.28,500.52c-3.73-1.25-7.66-2.12-11.17-3.83-16.23-7.9-23.84-21.27-23.85-39.12q-.06-74.74,0-149.48c0-30.4-.09-60.81,0-91.21.08-21.2,13.05-37.52,32.92-41.54a53.36,53.36,0,0,1,10.43-.74q58.38-.06,116.77,0c26.43,0,43.36,17.11,43.37,43.74q0,118.67,0,237.34c0,24.13-10.92,38.25-34.24,44.35a3,3,0,0,0-.79.51Zm66.84-264.79a61.11,61.11,0,1,0,0,122.21c33.28.06,61-27.78,60.9-61.19C316.93,263,289.62,235.61,256.12,235.73ZM195.24,398.86v40.3h40.22v-40.3Zm121.52,40.33V398.88H276.57v40.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.45,11.48c8.39,1.6,16.89,2.74,25.13,4.88a138.38,138.38,0,0,1,63.31,36.16L327.2,81.16C307.82,62.69,284,52.32,256,52.32S204.42,62.6,184.6,81.43L156.05,52.72a130.43,130.43,0,0,1,27.53-21.35A140.36,140.36,0,0,1,241.4,12.28a22.29,22.29,0,0,0,3.17-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67,110.88l-28.35,28.39c-9.23-7.22-18.8-7.7-27.92-.42L214,110.27C233.11,87.31,278.08,87.26,298.67,110.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.93,337.39a40.69,40.69,0,1,1,40.79-40.45A40.72,40.72,0,0,1,255.93,337.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteOperations);
export default __webpack_public_path__ + "static/media/remoteOperations.f348f0c91c39dd9080e1c808eaf55e84.svg";
export { ForwardRef as ReactComponent };